import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentdataService {
  apiPrefix: any;
  headers = new HttpHeaders();

  constructor(
    private http: HttpClient
  ) {
    this.apiPrefix = environment.baseUrl + 'api/v1/';
    this.headers = this.headers.set(
      'x-access-token',
      localStorage.getItem('adminAuthTokenTNT')
    );
  }

  getAllReports(payload) {
    return this.http.post(this.apiPrefix + 'bug/list', payload, {
      headers: this.headers,
    });
  }

  getAllFeedbacks(payload) {
    return this.http.post(this.apiPrefix + 'feedback/list', payload, {
      headers: this.headers,
    });
  }

  getAllFeatures(payload) {
    return this.http.post(this.apiPrefix + 'feature/list', payload, {
      headers: this.headers,
    });
  }
}
